import styled from 'styled-components'
import { VerificationBackground } from 'src/assets'
export const SideWrapper = styled.div`
  font-family: inter;
  width: 50% !important;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-image: url(${VerificationBackground});
  background-size: cover;
  background-repeat: no-repeat;
  color: white;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    display: none;
  }
`
export const Container = styled.div`
  padding: 30px 100px;
  height: 100vh;
  display: flex;
  /* justify-content: space-around; */
  flex-direction: column;
  .info {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 4.5rem;
      /* line-height: 150%; */
      color: ${({ theme }) => theme.colors.white};
    }
    p {
      font-style: italic;
      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      color: #e0e0e0;
    }
    .create {
      margin-top: -35px;
    }
    .speaker-note {
      display: flex;
      align-items: center;
      .speaker {
        padding-left: 20px;
        h3 {
          font-style: normal;
          font-weight: 600;
          font-size: 20px;
          line-height: 50%;
          color: ${({ theme }) => theme.colors.white};
        }
        p {
          font-style: italic;
          font-weight: 400;
          font-size: 16px;
          line-height: 50%;
          color: #e0e0e0;
        }
      }
    }
  }
`
